import React from 'react';
import styles from './SpotlightActorsSection.module.css';
import ActorCard from '../../../../components/common/ActorCard/ActorCard';

/**
 * @component ActorCardsGrid
 * @description 배우 카드 4-column 그리드 (랜딩 페이지 전용)
 */
function ActorCardsGrid({ actors, onCardClick }) {
  return (
    <div className={styles.actorCardsGrid}>
      {actors.map((actor) => (
        <ActorCard
          key={actor.id}
          image={actor.image}
          name={actor.name}
          gender={actor.gender}
          age={actor.age}
          height={actor.height}
          skills={actor.skills}
          onClick={() => onCardClick && onCardClick(actor.id)}
        />
      ))}
    </div>
  );
}

export default ActorCardsGrid;
